import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=308c5a0c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=308c5a0c&prod&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=308c5a0c&prod&lang=less&scoped=true&"
import style2 from "./detail.vue?vue&type=style&index=2&id=308c5a0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c5a0c",
  null
  
)

export default component.exports